import React, {useState} from 'react'
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";


// components
import {getStateByPath} from "../../../../redux/selectors";
import SelectGeneric from "../../../../components/select/selectGeneric";
import {GenericButton} from "../../../../components/buttons/customButtons";


// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {pageSectionService} from "../../../../jwt/_services/landings/pageSectionService";

// providers
import {sectionProvider} from "../../../../providers/landings/sectionProvider";

const LinkedSections = props => {
    const path = `${props.path}/sections`;

    const pageState = useSelector(state => getStateByPath(state, props.path));
    const {app, domainObject: page} = pageState?.data || {};
    const {fbDataBase} = app

    const [section, setSection] = useState(null)

    const handleLinkAmenity = () => {
        if(!section) return;

        const requestData = {
            fbDataBase,
            item:{
                page: {id: page?.id},
                section: {id: section}
            }
        }

        genericIndexedActions.save(path, pageSectionService, requestData, resetLabel)
    }

    const resetLabel = () => setSection(null)


    return <Row className={'mb-2em'}>
        <Col sm={9}>
            <SelectGeneric
                title={'Sección'}
                showSpinner={false}
                initialValue={section}
                setExternalValue={setSection}
                provider={sectionProvider}
            />
        </Col>
        <Col>
            <div className={'pt-2em pull-left'}>
                <GenericButton
                    clazz={'mt-2em'}
                    style={'table'}
                    label={'Vincular'}
                    toolTip={'Agregar Actividad'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={handleLinkAmenity}
                />
            </div>
        </Col>
    </Row>
}
export default LinkedSections;